var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-categories-show-view"
  }, [(_vm.category) ? _c('h1', [_vm._v(_vm._s(_vm.category.name))]) : (_vm.tenant) ? _c('h1', [_vm._v(_vm._s(_vm.tenant.name))]) : _vm._e(), _vm._v(" "), _c('link-button', {
    attrs: {
      "to": {
        name: 'new-product-category',
        query: {
          parentId: _vm.id,
          tenantId: _vm.tenantId
        }
      },
      "icon": "plus",
      "type": "primary"
    }
  }, [(_vm.id) ? _c('span', [_vm._v(_vm._s(_vm.$t('actions.newChild')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('actions.newRoot')))])]), _vm._v(" "), (_vm.category) ? _c('link-button', {
    attrs: {
      "to": {
        name: 'edit-product-category',
        params: {
          id: _vm.id
        }
      },
      "icon": "pencil"
    }
  }, [_vm._v(_vm._s(_vm.$t('actions.edit')))]) : _vm._e(), _vm._v(" "), (_vm.category) ? _c('common-button', {
    attrs: {
      "icon": "trash",
      "type": "danger"
    },
    on: {
      "click": _vm.deleteProductCategory
    }
  }, [_vm._v(_vm._s(_vm.$t('actions.delete')))]) : _vm._e(), _vm._v(" "), (_vm.showCategoryList) ? _c('search-input', {
    ref: "search",
    staticClass: "uk-align-right",
    model: {
      value: (_vm.searchQuery),
      callback: function($$v) {
        _vm.searchQuery = $$v
      },
      expression: "searchQuery"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showCategoryList) ? [(_vm.category) ? _c('h3', [_vm._v(_vm._s(_vm.$t('headlines.subCategories')))]) : _vm._e(), _vm._v(" "), (_vm.gridLoaded) ? _c('data-grid', {
    staticClass: "uk-margin-medium",
    attrs: {
      "columns": _vm.gridColumns,
      "is-loading": _vm.isLoading,
      "page-info": _vm.productCategories.pagination,
      "rows": _vm.productCategories.entries,
      "sort-info": _vm.productCategories.sort,
      "sortable": ['name', 'categoryNumber', 'updatedAt']
    },
    on: {
      "sort": _vm.sortBy
    },
    scopedSlots: _vm._u([{
      key: "name",
      fn: function(props) {
        return [_c('router-link', {
          attrs: {
            "to": {
              name: 'product-category',
              params: {
                id: props.row.id
              }
            }
          }
        }, [_vm._v(_vm._s(props.value))])]
      }
    }, {
      key: "categoryNumber",
      fn: function(props) {
        return [(props.value) ? _c('span', [_vm._v(_vm._s(props.value))]) : _c('text-placeholder')]
      }
    }, {
      key: "updatedAt",
      fn: function(props) {
        return [_c('timeago', {
          attrs: {
            "auto-update": 60,
            "since": props.value
          }
        })]
      }
    }, {
      key: "actions",
      fn: function(props) {
        return [_c('data-grid-actions', {
          attrs: {
            "edit-route": {
              name: 'edit-product-category',
              params: {
                id: props.row.id
              }
            }
          },
          on: {
            "remove": function($event) {
              _vm.deleteRecordWhenConfirmed(props.row)
            }
          }
        })]
      }
    }])
  }, [_c('span', {
    slot: "empty"
  }, [_vm._v(_vm._s(_vm.$t('hints.empty')))])]) : _c('div', {
    staticClass: "loader-container uk-container uk-margin-medium-top uk-text-center"
  }, [_c('loader')], 1)] : _vm._e(), _vm._v(" "), (_vm.category) ? [_c('h3', [_vm._v(_vm._s(_vm.$t('headlines.attributes')))]), _vm._v(" "), _c('attribute-table', {
    attrs: {
      "data": _vm.category,
      "fields": [
        'name',
        'ancestors',
        'categoryNumber',
        'path',
        'aliases',
        'insertedAt',
        'updatedAt'
      ]
    },
    scopedSlots: _vm._u([{
      key: "aliases",
      fn: function(aliases) {
        return [(aliases.value.length) ? _c('span', [_vm._v(_vm._s(aliases.value.join(', ')))]) : _c('text-placeholder')]
      }
    }, {
      key: "ancestors",
      fn: function(ancestors) {
        return [(ancestors.value.length) ? _c('product-category-path', {
          attrs: {
            "categories": ancestors.value
          },
          scopedSlots: _vm._u([{
            key: "item",
            fn: function(props) {
              return [_c('router-link', {
                attrs: {
                  "to": {
                    name: 'product-category',
                    params: {
                      id: props.category.id
                    }
                  }
                }
              }, [_vm._v(_vm._s(props.category.name))])]
            }
          }])
        }) : _c('text-placeholder')]
      }
    }, {
      key: "insertedAt",
      fn: function(insertedAt) {
        return [_c('timeago', {
          attrs: {
            "auto-update": 60,
            "since": insertedAt.value
          }
        })]
      }
    }, {
      key: "updatedAt",
      fn: function(updatedAt) {
        return [_c('timeago', {
          attrs: {
            "auto-update": 60,
            "since": updatedAt.value
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t('headlines.productFamilies')))]), _vm._v(" "), (_vm.category) ? _c('link-button', {
    attrs: {
      "to": {
        name: 'product-families',
        query: {
          categoryId: _vm.id
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('actions.showProductFamilies')))]) : _vm._e()] : _vm._e()], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-38c0a555","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./views/ProductCategories/ShowView.vue
// module id = 1932
// module chunks = 0